var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 57,
    x: 1.5,
    y: 1.5,
    fill: "#fff",
    rx: 28.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 57,
    x: 1.5,
    y: 1.5,
    stroke: "#97AEBD",
    strokeWidth: 3,
    rx: 28.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001925",
    fillRule: "evenodd",
    d: "M19.286 18.097a2.927 2.927 0 0 1 4.186 0L31 25.746l7.528-7.65a2.927 2.927 0 0 1 4.186 0 3.04 3.04 0 0 1 0 4.255L35.187 30l7.527 7.649a3.04 3.04 0 0 1 0 4.254 2.927 2.927 0 0 1-4.186 0L31 34.253l-7.527 7.65a2.927 2.927 0 0 1-4.187 0 3.04 3.04 0 0 1 0-4.254l7.528-7.65-7.528-7.648a3.04 3.04 0 0 1 0-4.254",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCloseIcon);
export default __webpack_public_path__ + "static/media/btn-close-Icon.c6a733aeed6a7a18b12b95bea917fa20.svg";
export { ForwardRef as ReactComponent };